import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@jotta/utils/css'

import styles from './AlbumsSectionHeader.module.scss'

export function AlbumsSectionHeader({
  title,
  countLabel,
  className,
  ...props
}: {
  title: string
  countLabel?: string
  className?: string
} & Omit<ComponentPropsWithoutRef<'h2'>, 'children'>) {
  return (
    <h2
      className={cn(
        'h2 mb-2 mt-0 flex items-baseline gap-2 font-medium text-primary',
        styles.header,
        className,
      )}
      {...props}
    >
      {title}
      {!!countLabel && (
        <small
          className={cn(
            'body-sm-sh font-normal text-primary opacity-50',
            styles.count,
          )}
        >
          {countLabel}
        </small>
      )}
    </h2>
  )
}
